import { CellTable } from "@/atoms"
import { AiAdr } from "@/icons"
import { IconTextCell } from "@/molecules/IconTextCell"

import styles from "./AgentNameCell.module.scss"

import type { AgentAiApi } from "@/api/useInventory.types"

export const AgentNameCell = (
  name: string,
  record?: Pick<AgentAiApi, "isGeneratedName">
) =>
  record?.isGeneratedName ? (
    <IconTextCell
      text={name}
      iconPosition="end"
      icon={
        <AiAdr
          data-tooltip-content="inventory.ai.generatedName"
          data-tooltip-translation
        />
      }
      classes={{ container: styles.container, icon: styles.icon }}
    />
  ) : (
    CellTable(name)
  )
